import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
//

import { ChairProvider } from "./UseContextChairHandlers";
import { ChairColorsProvider } from "./useContextColorsChair";

//
//
import ReactRouterScrollToTop from "./RouterScrollToTop";
import About from "./components/About/About";
import NavScroll from "./components/NavScroll/NavScroll";
import AllProducts from "./components/AllProducts/AllProducts";
import Home from "./pages/Home";
import ProductScreen from "./screens/ProductScreen";
import Footer from "./components/Footer/Footer";

const App = () => {
  return (
    <ChairProvider>
      <ChairColorsProvider>
        <Router>
          <ReactRouterScrollToTop />
          <NavScroll />
          <div className="page">
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/about" exact component={About} />
              <Route path="/allProducts" exact component={AllProducts} />
              <Route path="/product/:id" component={ProductScreen} />
              <Route path="/*" component={Home} />
            </Switch>
          </div>
          <Footer />
        </Router>
      </ChairColorsProvider>
    </ChairProvider>
  );
};

export default App;
